import Logo from "./Logo";

const LINKS = [
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export function scrollToHash(href) {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
}

export default function Navbar() {
  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-md"
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-10">
        <button
          data-testid="nav-home-button"
          onClick={() => {
            if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.4 });
            else window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-3"
        >
          <Logo />
          <span className="font-jbmono text-xs tracking-[0.25em] uppercase text-white">
            Jacob Tobery
          </span>
        </button>

        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => scrollToHash(l.href)}
              className="link-underline font-jbmono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-button"
            onClick={() => scrollToHash("#contact")}
            className="rounded-full border border-[#00E5FF]/60 px-5 py-2 font-jbmono text-xs uppercase tracking-[0.2em] text-[#00E5FF] transition-colors duration-300 hover:bg-[#00E5FF] hover:text-black"
          >
            Let&apos;s talk
          </button>
        </div>

        <button
          data-testid="nav-cta-mobile"
          onClick={() => scrollToHash("#contact")}
          className="rounded-full border border-[#00E5FF]/60 px-4 py-2 font-jbmono text-[11px] uppercase tracking-[0.2em] text-[#00E5FF] md:hidden"
        >
          Talk
        </button>
      </nav>
    </header>
  );
}
